import { Switch, Route, Redirect } from 'react-router-dom';
import { useUserAuth } from '../state/userAuthContext';
import { servicesRoutes } from './allRoutes';
import useFiltersState from '../state/useFiltersState';
import { useEffect } from 'react';

const switchRoutes = (
  <Switch>
    {servicesRoutes.map((prop, key) => {
      if (prop.layout === 'logistic-service') {
        return <Route path={`/${prop.layout}${prop.path}`} component={prop.component} key={key} exact />;
      }
      return null;
    })}
    <Redirect from="/logistic-service" to="/listing" />
  </Switch>
);
const Services = () => {
  const { user } = useUserAuth();
  const { setLogisticsServicesFilters, setLogisticServicesSearchbarText, setLogisticsServicesListingFilters } =
    useFiltersState();

  useEffect(() => {
    return () => {
      setLogisticsServicesFilters([]);
      setLogisticServicesSearchbarText('');
      setLogisticsServicesListingFilters([]);
    };
  }, []);

  return <> {user && switchRoutes} </>;
};

export default Services;
